import React from 'react';

import type { WalletType } from 'types/client/wallets';
import type { WalletProvider } from 'types/web3';

import * as mixpanel from 'lib/mixpanel/index';
import { toaster } from 'toolkit/chakra/toaster';

import useAddChain from './useAddChain';
import useProvider from './useProvider';
import useSwitchChain from './useSwitchChain';

interface Props {
  source: 'Footer' | 'Top bar' | 'Chain widget';
  onSuccess?: () => void;
}

export default function useAddChainClick({ source, onSuccess }: Props) {
  const { data: { wallet: detectedWallet, provider: detectedProvider } = {} } = useProvider();
  const addChain = useAddChain();
  const switchChain = useSwitchChain();

  return React.useCallback(async(selectedWallet?: WalletType, selectedProvider?: WalletProvider) => {
    const wallet = selectedWallet || detectedWallet;
    const provider = selectedProvider || detectedProvider;

    if (!wallet || !provider) {
      return;
    }

    try {
      await addChain(provider);
      await switchChain();

      toaster.success({
        title: 'Success',
        description: 'Successfully added network to your wallet',
      });

      mixpanel.logEvent(mixpanel.EventTypes.ADD_TO_WALLET, {
        Target: 'network',
        Wallet: wallet,
        Source: source,
      });

      onSuccess?.();
    } catch (error) {
      toaster.error({
        title: 'Error',
        description: (error as Error)?.message || 'Something went wrong',
      });
    }
  }, [ addChain, detectedProvider, detectedWallet, switchChain, source, onSuccess ]);
}
